export default __webpack_public_path__ + "static/writer-1-6a07e65b0a693e6b04d87cab777ccb63.png";